<template>
  <section class="mt-4 mb-5">
    <vue-headful
      :title="`การขอใบ ป.3 (อนุญาตซื้อปืน) - Thong Firearms ร้านปืนธง`"
      description="ต้องการมีปืนเพื่อป้องกันชีวิตและทรัพย์สิน หรือ เพื่อการกีฬา
          ที่ถูกต้องตามกฎหมายต้องทำอย่างไร ท่านต้องมีใบป.3(อนุญาตซื้อปืน) มาซื้อที่ร้านเท่านั้น ต้องไปขอที่ไหน"
      keyword="การขอใบ ป.3, ซื้อปืน, อนุญาตซื้อปืน, หลักฐานการซื้อปืน"
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <div class="container">
      <h1 class="text-center">การขอใบ ป.3</h1>
      <article>
        <h6>
          ต้องการมีปืนเพื่อป้องกันชีวิตและทรัพย์สิน หรือ เพื่อการกีฬา
          ที่ถูกต้องตามกฎหมายต้องทำอย่างไร ?
        </h6>
        <p>ท่านต้องมีใบป.3 (อนุญาตซื้อปืน) มาซื้อที่ร้านเท่านั้น</p>
        <p>
          *การจัดส่งทางไปรษณีย์(ปืนและกระสุน) ปัจจุบันผิดกฎหมาย มีโทษขั้นรุนแรง
          ทั้งผู้ส่งและผู้รับ
        </p>
        <p>
          การขอใบป.3 (อนุญาตซื้อปืน) ต้องไปขอที่ไหน ?<br />แบ่งเป็น 2
          กลุ่มได้ดังนี้
        </p>
        <p>
          1. ผู้ที่มีทะเบียนบ้านอยู่ต่างจังหวัด
          ท่านสามารถไปขอได้ที่ว่าการอำเภอตามทะเบียนบ้านที่ท่านสังกัดอยู่
          เรื่องระเบียบการ ให้ไปถามที่อำเภอ เพราะแต่ละอำเภอไม่เหมือนกันครับ
        </p>
        <p class="mb-1">
          2. ผู้ที่มีทะเบียนบ้านอยู่กรุงเทพฯ ท่านสามารถไปขอได้ที่ กรมการปกครอง
          วังไชยา ใกล้ๆสนามม้านางเลิ้ง
          🎯สำหรับท่านที่มีทะเบียนบ้านอยู่กรุงเทพฯทางเรายินดีให้คำปรึกษาในการขอใบป.3
          เอกสารที่ใช้มีดังนี้
        </p>
        <ul>
          <li>
            สำเนาบัตรประชาชน
          </li>
          <li>
            สำเนาทะเบียนบ้าน(ต้องอยู่เกิน 6 เดือน)
          </li>
          <li>
            หลักฐานการทำงาน
          </li>
          <li>
            หลักทรัพย์(สำเนาสมุดบัญชีธนาคาร)
          </li>
          <li>
            พิมพ์ลายนิ้วมือตรวจประวัติ
          </li>
        </ul>
        <p class="text-danger"><b>**ห้ามเคยต้องคดีความ</b></p>
        <div class="text-center max-width">
          <a href="src/assets/ex-license.jpg" data-fancybox>
            <img
              class="border border-dark"
              src="../assets/ex-license.jpg"
              alt="ตัวอย่างใบ ป.3"
            />
          </a>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/component/license.vue